import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Prices } from "@/app/market/table";

interface TradeState {
  tps: { value: number; quantity: number }[];
  livePrice: Prices;
  entry?: number;
  tradeAction: string;
  tradeType: string;
  available?: string | number;
  stopLoss: string;
  trailingAction: string;
  trailingValue: string;
  trailingPrice?: string;
  trailing?: {
    trigger_value: string;
    stop_price: string;
  };
  entryTotal?: number;
  entryPrice?: string;
}

const initialState: TradeState = {
  tps: [],
  livePrice: {
    price: 0,
    provider: 0,
    symbol: "",
  },
  tradeAction: "buy",
  tradeType: "market",
  stopLoss: "",
  trailingAction: "breakeven",
  trailingValue: "",
};

const tradeSlice = createSlice({
  name: "trade",
  initialState,
  reducers: {
    setLivePrice(state, action: PayloadAction<Prices>) {
      state.livePrice = action.payload;
    },
    setTradeAction(state, action: PayloadAction<string>) {
      state.tradeAction = action.payload;
    },
    setTradeType(state, action: PayloadAction<string>) {
      state.tradeType = action.payload;
    },
    setAvailable(state, action: PayloadAction<any>) {
      state.available = action.payload;
    },
    setEntry(state, action: PayloadAction<number | undefined>) {
      state.entry = action.payload;
    },
    setEntryTotal(state, action: PayloadAction<number | undefined>) {
      state.entryTotal = action.payload;
    },
    setStopLoss(state, action: PayloadAction<string>) {
      state.stopLoss = action.payload;
    },
    setTPs(
      state,
      action: PayloadAction<{ value: number; quantity: number }[]>,
    ) {
      state.tps = action.payload;
    },
    setTrailingAction(state, action: PayloadAction<string>) {
      state.trailingAction = action.payload;
    },
    setTrailingValue(state, action: PayloadAction<string>) {
      state.trailingValue = action.payload;
    },
    setTrailingPrice(state, action: PayloadAction<string>) {
      state.trailingPrice = action.payload;
    },
    setEntryPrice(state, action: PayloadAction<string | undefined>) {
      state.entryPrice = action.payload;
    },
    setTrailing(
      state,
      action: PayloadAction<{
        trigger_value: string;
        stop_price: string;
      }>,
    ) {
      state.trailing = action.payload;
    },
    resetTrade() {
      return { ...initialState, entry: 0, entryTotal: 0, available: "refresh" };
    },
  },
});

export const {
  setLivePrice,
  setTradeAction,
  setTradeType,
  setEntryPrice,
  setAvailable,
  setEntry,
  setEntryTotal,
  setStopLoss,
  setTPs,
  setTrailingAction,
  setTrailingValue,
  setTrailingPrice,
  setTrailing,
  resetTrade,
} = tradeSlice.actions;
export default tradeSlice.reducer;
